<template>
  <div class="p-8 bg-[#F4F7FB] min-h-screen">
    <header class="flex lg:flex-row justify-between items-start lg:items-center mb-10 gap-6">
      <div>
        <h1 class="text-4xl font-black text-[#222222] tracking-tighter">SuperAdmin Global</h1>
        <p class="text-gray-500 font-medium">Pilotage centralisé de l'écosystème SaaS Datafuse.</p>
      </div>
      
      <div class="flex gap-4 bg-white p-2 rounded-2xl shadow-sm border border-gray-100">
        <div class="px-4 py-2 text-center border-r border-gray-100">
          <p class="text-[10px] font-black text-gray-400 uppercase">Revenu Mensuel (MRR)</p>
          <p class="text-xl font-black text-green-600">12,450 €</p>
        </div>
        <div class="px-4 py-2 text-center">
          <p class="text-[10px] font-black text-gray-400 uppercase">Clients Actifs</p>
          <p class="text-xl font-black text-[#222222]">128</p>
        </div>
      </div>
    </header>

    <div class="grid xl:grid-cols-4 gap-8">
      
      <div class="xl:col-span-3 space-y-8">
        
        <div class="bg-white rounded-[2.5rem] p-8 shadow-sm border border-gray-100">
          <div class="flex justify-between items-center mb-8">
            <h2 class="text-sm font-black uppercase tracking-[0.2em] text-gray-400">Activité Réseau (Dernières 24h)</h2>
            <select class="text-xs font-bold bg-gray-50 border-none rounded-lg px-3 py-1 text-gray-500">
              <option>Tous les clusters</option>
              <option>Europe - Paris</option>
            </select>
          </div>
          
          <div class="h-48 w-full flex items-end gap-1 mb-6">
            <div v-for="h in 24" :key="h" 
                 :style="{ height: Math.random() * 100 + '%' }" 
                 class="flex-1 bg-blue-400 hover:bg-blue-700 rounded-t-sm transition-all group relative">
               <div class="absolute -top-8 left-1/2 -translate-x-1/2 bg-black text-white text-[8px] p-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                 {{ Math.floor(Math.random() * 500) }} tickets
               </div>
            </div>
          </div>
          <p class="text-center text-[10px] font-bold text-gray-400 uppercase tracking-widest">Pics d'affluence par heure sur l'ensemble du SaaS</p>
        </div>

        <div class="bg-white rounded-[2.5rem] shadow-sm border border-gray-100 overflow-hidden">
          <div class="p-8 flex justify-between items-center">
            <h2 class="text-sm font-black uppercase tracking-[0.2em] text-gray-400">Classement Licences</h2>
            <button class="text-xs font-bold text-dimotec-orange">Voir tout le billing</button>
          </div>
          <table class="w-full">
            <thead class="bg-gray-50 text-[10px] font-black text-gray-400 uppercase tracking-widest text-left">
              <tr>
                <th class="px-8 py-4">Compte</th>
                <th class="px-6 py-4">Plan</th>
                <th class="px-6 py-4">Utilisation Hardware</th>
                <th class="px-8 py-4 text-right">Facturation</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-50">
              <tr v-for="client in topClients" :key="client.id" class="hover:bg-gray-50/50">
                <td class="px-8 py-5">
                  <p class="font-bold text-gray-900">{{ client.name }}</p>
                  <p class="text-[10px] text-gray-400 uppercase">{{ client.region }}</p>
                </td>
                <td class="px-6 py-5">
                  <span class="px-2 py-1 bg-purple-50 text-purple-600 rounded text-[9px] font-black uppercase tracking-tighter">{{ client.plan }}</span>
                </td>
                <td class="px-6 py-5">
                  <div class="flex gap-4">
                    <span class="text-xs font-bold text-gray-600">🖨️ {{ client.bornes }}</span>
                    <span class="text-xs font-bold text-gray-600">📺 {{ client.tv }}</span>
                  </div>
                </td>
                <td class="px-8 py-5 text-right">
                  <p class="font-black text-gray-900">{{ client.mrr }}€/mois</p>
                  <span class="text-[9px] font-bold text-green-500 uppercase">Payé</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="space-y-8">
        
        <div class="bg-[#222222] rounded-[2.5rem] p-8 text-white shadow-xl">
          <h3 class="text-xs font-black uppercase tracking-widest text-dimotec-orange mb-6">Infrastucture Cloud</h3>
          
          <div class="space-y-6">
            <div v-for="node in nodes" :key="node.name" class="flex items-center justify-between">
              <div>
                <p class="text-xs font-bold">{{ node.name }}</p>
                <p class="text-[9px] text-gray-500 font-mono">{{ node.ip }}</p>
              </div>
              <div class="text-right">
                <p class="text-xs font-black" :class="node.load > 80 ? 'text-red-500' : 'text-green-500'">{{ node.load }}%</p>
                <div class="w-12 h-1 bg-gray-800 rounded-full mt-1 overflow-hidden">
                  <div class="h-full bg-current transition-all" :style="{ width: node.load + '%' }"></div>
                </div>
              </div>
            </div>
          </div>

          <button class="w-full mt-10 py-3 border border-white/10 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-white/5 transition">
            Redémarrer Cluster Global
          </button>
        </div>

        <div class="bg-white rounded-[2.5rem] p-8 border border-gray-100 shadow-sm">
          <h3 class="text-xs font-black uppercase tracking-[0.2em] text-gray-400 mb-6">Alertes Système</h3>
          <div class="space-y-4">
            <div class="p-4 bg-red-50 rounded-2xl border border-red-100">
               <p class="text-[10px] font-black text-red-600 uppercase mb-1 italic">Billing Fail</p>
               <p class="text-xs font-bold text-red-800">Media Link : Échec du prélèvement Stripe.</p>
            </div>
            <div class="p-4 bg-blue-50 rounded-2xl border border-blue-100">
               <p class="text-[10px] font-black text-blue-600 uppercase mb-1 italic">Quota Reach</p>
               <p class="text-xs font-bold text-blue-800">Pharmacie Soleil a atteint son quota de tickets mensuels.</p>
            </div>
          </div>
        </div>

        <div class="bg-gray-900 rounded-[2rem] p-6 text-[10px] font-mono text-gray-400">
          <div class="flex items-center gap-2 mb-4 border-b border-white/5 pb-2">
            <div class="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span class="text-white font-bold">Audit Log</span>
          </div>
          <p><span class="text-dimotec-orange">14:22</span> root.login (Success)</p>
          <p><span class="text-dimotec-orange">14:18</span> api.key_generated (ID: 92)</p>
          <p><span class="text-dimotec-orange">14:05</span> client.suspended (ID: 04)</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topClients: [
        { id: 1, name: "Media Link Solutions", region: "Occitanie", plan: "Enterprise", bornes: 12, tv: 25, mrr: 1200 },
        { id: 2, name: "Dimotec Diagnostics", region: "PACA", plan: "Pro", bornes: 5, tv: 8, mrr: 450 },
        { id: 3, name: "Pharmacie du Soleil", region: "Île-de-France", plan: "Starter", bornes: 1, tv: 2, mrr: 89 }
      ],
      nodes: [
        { name: "Node-Paris-01", ip: "10.0.4.12", load: 34 },
        { name: "Node-Marseille-02", ip: "10.0.5.88", load: 82 },
        { name: "WebSocket-Gateway", ip: "10.0.0.1", load: 12 }
      ]
    }
  }
}
</script>